/** API route map: URLS.Controller.InterviewRemarks */
export const InterviewRemarks = {
      Name: 'InterviewRemarks/',
      GetAllInterviewRemarks: 'get-all-interview-remarks',
      AddInterviewRemarks: 'add-interview-remarks',
      UpdateRemarks: 'update',
      DeleteRemarks: 'delete',
};
